export const CHROME_STORE_URL =
  "https://chromewebstore.google.com/detail/interpreter-income-tracke/kggkedakncjapfgbdgellnilljjongbo";

export const ZIP_FALLBACK_HREF = "/downloads/minutepay-extension.zip";
